export function getCeilNum(value: number) {
  const dec = +'10000000'.slice(0, Math.ceil(value).toString().length);
  return Math.ceil(value / dec) * dec;
}

export function getFloorNum(value: number) {
  const dec = +'10000000'.slice(0, Math.ceil(value).toString().length);
  return Math.floor(value / dec) * dec;
}
